export default customElements.define('w-field-textbox', class FieldTextbox extends wealthify.componentBases.FieldText {

    constructor () {
        super();
    }

    static styleSelector = 'c-field-textbox';
    static validationProps = [
        wealthify.FieldValidation.validationPropEnums.Pattern
    ];

    static get observedProps () {
        return [
            new wealthify.Prop('autocompleteprop', {default: ''}),
        ];
    }

    static get formatEnums() {
        return {
            Name: 'name',
            Email:'email'
        };
    }


    /*eslint-disable no-useless-escape*/
    // Regex patterns defined as string, so escapes required
    // Following the RFC spec - https://www.mailboxvalidator.com/resources/articles/acceptable-email-address-syntax-rfc/
    static emailRegexParts = {
        local: '[a-zA-Z0-9!#$%&‘*=_`~\\+\\-\\/\\?\\^\\{\\|\\}]+(\\.[a-zA-Z0-9!#$%&‘*=_`~\\+\\-\\/\\?\\^\\{\\|\\}]+)*',
        domain: '([a-zA-Z0-9]+)+([\\.\\-][a-zA-Z0-9]+)*',
        topLevel: '(\\.[a-zA-Z]{2,}){1,2}'
    }

    static get formatDictionary () {
        return {
            [this.formatEnums.Name]:{
                'allowedcharacters': '[^!-&(-,.-@[-`{-~¡-¿×÷]',
                'autocompleteprop': 'name'
            },
            [this.formatEnums.Email]:{
                'allowedcharacters': '[a-zA-Z0-9!#$%&‘*+-/=?^_`.{|}~@]',
                'autocompleteprop': 'email',
                [wealthify.FieldValidation.validationPropEnums.Pattern]: `\/^${this.emailRegexParts.local}@${this.emailRegexParts.domain}${this.emailRegexParts.topLevel}$\/`,
                [wealthify.FieldValidation.messagePropEnums.Pattern]: 'The email address is invalid',
            }
        };
    }

    get propCallbacks () {
        return {autocompleteprop: () => this.#updateAutocompleteProp(),};
    }

    #updateAutocompleteProp () {
        const hasValue = this.autocompleteprop !== '';
        const isList = hasValue && this.autocompleteprop.indexOf('#') !== -1;

        if (!hasValue) {
            this.dom.fieldinput.removeAttribute('list');
            this.dom.fieldinput.setAttribute('autocomplete', 'off');

            return;
        }

        if (isList) {
            const list = this.autocompleteprop.split('#')[1];

            this.dom.fieldinput.setAttribute('list', list);
        } else {
            this.dom.fieldinput.setAttribute('autocomplete', this.autocompleteprop);
        }
    }

});